export default {
    form: {
        errors: {
            studyStart: 'Start date has to be before graduation date',
            schoolId: 'Missing school',
            studyProgramId: 'Missing study program',
        },
    },
};
